<div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal-popin"
     aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" bsModal>
    <div class="modal-content">
      <div class="block block-themed block-transparent mb-0">
        <div class="block-header bg-primary-dark">
          <h3 class="block-title">Booking Partner Payouts</h3>
          <div class="block-options">
            <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close"
                    (click)="hideChildModal()">
              <i class="si si-close"></i>
            </button>
          </div>
        </div>

        <!-- -->
        <div class="block-content block-content-full" *ngIf="booking != null">
          <form [formGroup]="form" class="payouts-form" novalidate>
            <div formArrayName="rows">

              <div
                class="row"
                *ngFor="let group of rows.controls; let i = index; trackBy: trackByIndex"
                [formGroupName]="i"
              >
                <div class="col-12">

                  <div class="row">
                    <div class="col-12">
                      <h6>Transaction Settings</h6>
                    </div>
                  </div>


                  <div class="form-group row"
                       [ngClass]="{'is-invalid': group.get('amount').dirty === true && group.get('amount').status === 'INVALID'}">
                    <div class="col-5">
                      Amount
                    </div>
                    <div class="col-5">
                      <input type="number" class="form-control" id="amount" name="amount"
                             placeholder="Amount" formControlName="amount">
                      <div class="invalid-feedback"
                           *ngFor="let error of extractValidationErrorsAsArray(group.get('amount').errors)">{{error}}
                      </div>
                    </div>
                    <div class="col-2">
                      {{ group.get('currency')?.value }}
                    </div>
                  </div>

                  <div class="form-group row"
                       [ngClass]="{'is-invalid': group.get('scheduledFor').dirty === true && group.get('scheduledFor').status === 'INVALID'}">
                    <div class="col-5">
                      Scheduled For
                    </div>
                    <div class="col-5">
                      <label class="css-control css-control-success css-switch">
                        <input type="text"
                               class="form-control"
                               bsDatepicker
                               placeholder="Datepicker"
                               formControlName="scheduledFor"
                               name="scheduledFor"
                               [bsConfig]="{dateInputFormat: 'DD.MM.YYYY', adaptivePosition: true}">
                      </label>
                      <div class="invalid-feedback"
                           *ngFor="let error of extractValidationErrorsAsArray(group.get('scheduledFor').errors)">{{error}}
                      </div>
                    </div>
                  </div>

                  <div class="form-group row"
                       [ngClass]="{'is-invalid': group.get('isScheduledForTransaction').dirty === true && group.get('isScheduledForTransaction').status === 'INVALID'}">
                    <div class="col-5">
                      Scheduled for Transaction
                    </div>
                    <div class="col-7">
                      <label class="css-control css-control-success css-switch">
                        <input type="checkbox" class="css-control-input" id="isScheduledForTransaction"
                               name="isScheduledForTransaction"
                               formControlName="isScheduledForTransaction">
                        <span class="css-control-indicator"></span>
                      </label>
                      <div class="invalid-feedback"
                           *ngFor="let error of extractValidationErrorsAsArray(group.get('isScheduledForTransaction').errors)">{{error}}
                      </div>
                    </div>
                  </div>

                  <div class="form-group row"
                       [ngClass]="{'is-invalid': group.get('link').dirty === true && group.get('link').status === 'INVALID'}">
                    <div class="col-5">
                      Import via Link
                    </div>
                    <div class="col-5">
                      <input type="text" class="form-control" id="link" name="link"
                             placeholder="Revolut Link" formControlName="link">
                      <div class="invalid-feedback"
                           *ngFor="let error of extractValidationErrorsAsArray(group.get('link').errors)">{{error}}
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <br>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <h6>Further Details</h6>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-5">
                      Internal ID
                    </div>
                    <div class="col-7">
                      {{ group.get('_id')?.value }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-5">
                      Draft ID
                    </div>
                    <div class="col-7">
                      {{ group.get('revolutPaymentDraftId')?.value }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-5">
                      Payment ID
                    </div>
                    <div class="col-7">
                      {{ group.get('revolutPaymentId')?.value }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-5">
                      Transaction ID
                    </div>
                    <div class="col-7">
                      {{ group.get('revolutTransactionId')?.value }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-5">
                      Transaction State
                    </div>
                    <div class="col-7">
                      {{ group.get('transactionState')?.value }}
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12"><br></div>
                  </div>

                  <div class="row">
                    <div class="col-3">
                      &nbsp;
                    </div>
                    <div class="col-3 text-left">
                      <button type="button" class="btn btn-sm btn-danger"
                              (click)="handleRemoveElement(i)"
                              [disabled]="group.get('paymentState')?.value === 'COMPLETED' || group.get('revolutTransactionId')?.value != null"
                      >Delete
                      </button>
                    </div>
                    <div class="col-3 text-right">
                      <button type="button" class="btn btn-sm btn-success"
                              (click)="handleUpdateElement(i)"
                              [disabled]="group.get('paymentState')?.value === 'COMPLETED' || group.get('revolutTransactionId')?.value != null"
                      >Save
                      </button>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <hr>
                    </div>
                  </div>


                </div>
              </div>

            </div>
          </form>

          <div class="row">
            <div class="col-12">&nbsp;</div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <h6>Add another Payout</h6>
            </div>
          </div>
          <form [formGroup]="formAdd" novalidate>

            <div class="form-group row"
                 [ngClass]="{'is-invalid': formAdd.get('amount').dirty === true && formAdd.get('amount').status === 'INVALID'}">
              <div class="col-5">
                Amount
              </div>
              <div class="col-5">
                <input type="number" class="form-control" id="amount" name="amount"
                       placeholder="Amount" formControlName="amount">
                <div class="invalid-feedback"
                     *ngFor="let error of extractValidationErrorsAsArray(formAdd.get('amount').errors)">{{error}}
                </div>
              </div>
            </div>

            <div class="form-group row"
                 [ngClass]="{'is-invalid': formAdd.get('scheduledFor').dirty === true && formAdd.get('scheduledFor').status === 'INVALID'}">
              <div class="col-5">
                Scheduled For
              </div>
              <div class="col-5">
                <label class="css-control css-control-success css-switch">
                  <input type="text"
                         class="form-control"
                         bsDatepicker
                         placeholder="Datepicker"
                         formControlName="scheduledFor"
                         name="scheduledFor"
                         [bsConfig]="{dateInputFormat: 'DD.MM.YYYY', adaptivePosition: true}">
                </label>
                <div class="invalid-feedback"
                     *ngFor="let error of extractValidationErrorsAsArray(formAdd.get('scheduledFor').errors)">{{error}}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-10 text-right">
                <button type="button" class="btn btn-sm btn-success"
                        (click)="handleAddElement()"
                >Add Payment
                </button>
              </div>
            </div>

          </form>
        </div>
        <!-- -->


      </div>
      <div class="modal-footer">
          <div class="col-6 text-left">
            <button type="button" class="btn btn-alt-info" data-dismiss="modal" (click)="handleToggleHundredPercentPayout()" *ngIf="booking != null">
              <ng-container *ngIf="is100PercentPayout === false">Enable 100% Payout</ng-container>
              <ng-container *ngIf="is100PercentPayout === true">Disable 100% Payout</ng-container>
            </button>
          </div>
          <div class="col-6 text-right">
            <button type="button" class="btn btn-alt-secondary" data-dismiss="modal" (click)="hideChildModal()">Close
            </button>
          </div>

      </div>
    </div>
  </div>
</div>

